import React from 'react'
import { Badge } from 'reactstrap'
import { Link } from 'react-router-dom'
import { Avatar } from '../../Components/Common'

export const instructorColumns = (layout, role) => [
	{
		name: 'Avatar',
		selector: (row) => row.avatar_url,
		sortable: false,
		width: '80px',
		cell: (row) => (
			<div className="d-flex align-items-center">
				<Avatar avatar_url={row.avatar_url} id={row.id} layout={layout} role={role} entityType="instructors" />
			</div>
		)
	},
	{
		name: 'Name',
		selector: (row) => row.name || '',
		sortable: true,
		cell: (row) => (
			<div style={{ cursor: 'pointer' }}>
				<Link to={`${process.env.PUBLIC_URL}/${role}/instructors/detail/${row.id}/${layout}`} className="text-decoration-none text-dark">
					<div>{row.name + ' ' + row.surname || 'N/A'}</div>
				</Link>
			</div>
		)
	},
	{
		name: 'Email',
		selector: (row) => row.email || '',
		sortable: true,
		cell: (row) => (
			<div className="text-truncate" style={{ maxWidth: '200px' }}>
				{row.email || 'N/A'}
			</div>
		)
	},
	{
		name: 'Phone',
		selector: (row) => row.phone || '',
		sortable: true,
		cell: (row) => <div>{row.phone || 'N/A'}</div>
	},
	{
		name: 'Status',
		selector: (row) => row.isActive,
		sortable: true,
		cell: (row) => (
			<Badge color={row.isActive ? 'success' : 'secondary'} className="px-2 py-1">
				{row.isActive ? 'Active' : 'Inactive'}
			</Badge>
		)
	}
]
